import React from 'react';
import cn from "classnames";
import CONFIG from "../../config";

const { LINKS } = CONFIG;

interface ILoans {
    className?: string;
}

const Loans: React.FC<ILoans> = ({ className }) => (
    <ul className={cn(className)}>
        <li><a href={LINKS.BAIBOL.LOANS} target="_blank" rel="noopener noreferrer nofollow">Получить заём</a></li>
        <li><a href="/">Оплатить заём</a></li>
        {/*<li><a href={LINKS.BAIBOL.BUY_HISTORY} target="_blank" rel="noopener noreferrer nofollow">Проверить кредитную историю</a></li>*/}
    </ul>
);

export default Loans;
